import { render } from "./ShiftSlotListing.vue?vue&type=template&id=819933ce&scoped=true"
import script from "./ShiftSlotListing.vue?vue&type=script&lang=js"
export * from "./ShiftSlotListing.vue?vue&type=script&lang=js"

import "./ShiftSlotListing.vue?vue&type=style&index=0&id=819933ce&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-819933ce"]])

export default __exports__